import { Form, BaseModel, Resource, Entry, EntryTypes, CardMode, TwoColumnLayout, TableMode } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { jourTransform, jourOptions } from '../../shared/resource/select-options-static';
import { InscriptionModel } from '../../shared/inscriptions/inscription.model';
import { anneeScolaireFetchOptions, cycleFetchOptions } from '../../shared/resource/select-options';
import { DateHelper } from '../../shared/helpers/date.helper';
import { CoursReducer, CoursEpics } from './cours.store';
import { EleveModel } from '../../eleve/models/eleve.model';
import { ValueFormatterService } from '../../../../node_modules/ag-grid';
import { TABLE } from '../../app.constantes';
import { Validators } from '@angular/forms';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/cours',
            methods: LeaResource.methods,
        }
    },
    store: {
        namespace: 'cours',
        reducer: CoursReducer,
        epics: CoursEpics,
    }
})
@Form({
    'create': {
        layout: TwoColumnLayout,
    },
    'edit': {
        layout: TwoColumnLayout,
    },
    'table': {},
    'table-prof': {},
    'show': {
        layout: TwoColumnLayout,
    },
})
export class CoursModel extends BaseModel {

    @Entry({
        base: {
            hidden: true,
        },
        'create': {}
    })
    _explicitType: string = 'Cours';

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            // label: 'Cours',
            hidden: true,
        },
        'show': {
            /*css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },*/
            layout: 'left',
            // hidden: false,
            // Attente correctif de Jérémy, peut-être un bug de NGX
            transform: (value, row) => 'Cours ' + ((row.type === true) ? 'collectif' : 'individuel') + ' N° ' + row.id,
        },
    })
    libelleEnteteShow: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'N°',
            hidden: true,
        },
        'edit': {
        },
        'show': {
            hidden: true,
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            layout: 'left',
        },
        'table': {
            colOrder: 0,
            minWidth: TABLE.MIN_WIDTH.ID,
        },
        'table-prof': {
            colOrder: 0,
            flexGrow: 1,
        },
    })
    id: string;

    @Entry({
        base: {
            type: EntryTypes.RADIO,
            label: 'Type de cours',
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4 align-left no-padding-top',
                input: 'col-xs-4',
            },
            options: [{
                value: false,
                label: 'Individuel'
            }, {
                value: true,
                label: 'Collectif'
            }],
        },
        'create': {},
        'show': {
            hidden: true,
        },
        'edit': {},
    })
    type: boolean = false; // true = cours collectif, false = individuel

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Cours fictif',
            }],
            css: {
                group: 'col-xs-6'
            }
        },
        'create': {},
        'edit': {},
    })
    isFictif: string; // Cours fictif pour inscriptions fictives (affichag d'un cursus uniquement)

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Année scolaire',
            css: {
                group: 'col-xs-6'
            },
            fetchOptions: anneeScolaireFetchOptions,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        }
    })
    anneeScolaire: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Discipline',
            css: {
                group: 'col-xs-6'
            },
            compareFn: (one, two) => one && two && one.id === two.id,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            layout: 'left',
            transform: (value) => value ? value.libelle : '',
        }
    })
    discipline: any;
    libelle: string;
    @Entry({
        base: {
            label: 'Discipline',
            flexGrow: 1,
            colOrder: 1,
            transform: (value, row) => row.discipline.libelle,
            hidden: true,
            minWidth: TABLE.MIN_WIDTH.DISCIPLINE,
        },
        'table': {
            hidden: false,
        },
        'table-prof': {
            hidden: false,
        },
    })
    disciplineLibelle: string;


    @Entry({
        base: {
            label: 'Capacité',
            type: EntryTypes.NUMBER,
            css: {
                group: 'col-xs-6'
            }
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'left',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        },
        'table': {
            colOrder: 20,
            hidden: true,
        }
    })
    nbElevesMax: number;
    @Entry({
        base: {
            label: 'Places dispo.',
            hidden: true,
        },
        'table': {
            colOrder: 21,
            hidden: true,
        }
    })
    nbPlacesDisponibles: number;

    coursJumeaux: string;




    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Professeur',
            // fetchOptions: professeurFetchOptions,
            css: {
                group: 'col-xs-6'
            },
            compareFn: (one, two) => one && two && one.id === two.id,
            transform: (value, row) => value ? `${value.nom} ${value.prenom}` : null,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
        'create': {},
        'edit': {},
        'table': {
            flexGrow: 1,
            colOrder: 2,
            hidden: true,
        },
        'table-prof': {
            hidden: true,
        },
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        },
    })
    professeur: any;
    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'Professeur',
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
            hidden: true,
            colOrder: 2,
        },
        'table': {
            hidden: false,
        },
        'table-prof': {
            hidden: true,
        },
    })
    professeurLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Accompagnateur',
            // fetchOptions: professeurFetchOptions,
            css: {
                group: 'col-xs-6'
            },
            compareFn: (one, two) => one && two && one.id === two.id,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            transform: (value, row) => value ? `${value.nom} ${value.prenom}` : null,
        }
    })
    accompagnateur: any;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Salle',
            // fetchOptions: salleFetchOptions,
            css: {
                group: 'col-xs-6'
            },
            compareFn: (one, two) => one && two && one.id === two.id,
            transform: (value, row) => value.nom,
            minWidth: TABLE.MIN_WIDTH.SALLE,
        },
        'create': {},
        'edit': {},
        'table': {
            flexGrow: 1,
            colOrder: 3,
            hidden: true,
        },
        'table-prof': {
            flexGrow: 1,
            colOrder: 3,
            hidden: true,
        },
        'show': {
            type: EntryTypes.STATIC,
            layout: 'left',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        }
    })
    salle: any;
    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'Salle',
            minWidth: TABLE.MIN_WIDTH.SALLE,
            hidden: true,
            colOrder: 3,
        },
        'table': {
            hidden: false,
        },
        'table-prof': {
            hidden: false,
        },
    })
    salleLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Cycle',
            // fetchOptions: cycleFetchOptions,
            css: {
                group: 'col-xs-6'
            },
            minWidth: TABLE.MIN_WIDTH.CYCLE,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            transform: (value, row) => (row.cycleLibelle) ? row.cycleLibelle : '',
        }
    })
    cycleCours: any;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Niveau',
            // fetchOptions: niveauFetchOptions,
            css: {
                group: 'col-xs-6'
            },
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            transform: (value, row) => (row.niveauLibelle) ? row.niveauLibelle : '',
        }
    })
    niveauCours: any;

    @Entry({
        base: {
            label: 'Niveau',
            flexGrow: 1,
            colOrder: 7,
            /*transform: (value, row) =>
                ((row.cycleLibelle) ? row.cycleLibelle + ' ' : '')
                + ((row.cycleLibelle && row.niveauLibelle) ? '/ ' : '')
                + ((row.niveauLibelle) ? row.niveauLibelle : ''),*/
            hidden: true,
            minWidth: TABLE.MIN_WIDTH.CYCLE,
        },
        'table': {
            hidden: false,
        },
        'table-prof': {
            hidden: false,
        }
    })
    libelleCycleNiveau: string;

    niveauLibelle: string;
    cycleLibelle: string;

    isHorsCursus: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Jour',
            options: [{value: null, label: ''}, ...jourOptions],
            css: {
                group: 'col-xs-6'
            },
            minWidth: TABLE.MIN_WIDTH.JOUR,
        },
        'create': {},
        'edit': {},
        'show': {
            label: 'Jour',
            type: EntryTypes.STATIC,
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8',
                group: 'col-xs-6',
            },
            layout: 'left',
            transform: jourTransform,
        },
        'table': {
            flexGrow: 1,
            transform: jourTransform,
            colOrder: 4,
        },
        'table-prof': {
            hidden: false,
            flexGrow: 1,
            transform: jourTransform,
            colOrder: 4,
        }
    })
    jour: number;

    @Entry({
        base: {
            label: 'Horaire',
            hidden: true,
            type: EntryTypes.STATIC,
            css: {
                group: 'col-xs-6'
            },
            transform: (value, row) => ((row.horaireDebut) ? DateHelper.minutesToHoursMin(row.horaireDebut) : '')
                + ' - '
                + ((row.horaireFin) ? DateHelper.minutesToHoursMin(row.horaireFin) : '')
                + ((row.duree) ? ' (' + row.duree + ' min)' : ''),
            minWidth: TABLE.MIN_WIDTH.HORAIRE,
        },
        'show': {
            hidden: false,
        }
    })
    horaire: string; // Pour afficher Horaire, début, fin et durée en consultation

    @Entry({
        base: {
            label: 'Heure début',
            type: EntryTypes.TIME,
            format: 'minutes',
            css: {
                group: 'col-xs-6',
                label: 'col-xs-4 align-left',
                input: 'col-xs-8',
            },
            minWidth: TABLE.MIN_WIDTH.HORAIRE,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            layout: 'left',
            transform: (value) => DateHelper.minutesToHoursMin(value),
            hidden: true,
        },
        'table': {
            flexGrow: 1,
            colOrder: 5,
            transform: (value) => DateHelper.minutesToHoursMin(value),
        },
        'table-prof': {
            flexGrow: 1,
            colOrder: 5,
            transform: (value) => DateHelper.minutesToHoursMin(value),
        }
    })
    horaireDebut: string;

    @Entry({
        base: {
            label: 'Durée',
            type: EntryTypes.NUMBER,
            css: {
                group: 'col-xs-6'
            },
            minWidth: TABLE.MIN_WIDTH.DUREE,
        },
        'create': {
            label: 'Durée (minutes)',
            validators: [Validators.min(0)],
            validatorsMsgs: { 'min': 'La durée doit être positive' },
        },
        'edit': {
            label: 'Durée (minutes)',
            validators: [Validators.min(0)],
            validatorsMsgs: { 'min': 'La durée doit être positive' },
        },
        'show': {
            hidden: true,
            type: EntryTypes.STATIC,
            layout: 'left',
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            transform: (value) => value + ' min',
        },
        'table': {
            flexGrow: 1,
            colOrder: 6,
        },
        'table-prof': {
            flexGrow: 1,
            colOrder: 6,
        }
    })
    duree: number;

    @Entry({
        base: {
            label: 'Heure fin',
            type: EntryTypes.TEXT,
            css: {
                group: 'col-xs-6'
            },
            minWidth: TABLE.MIN_WIDTH.HORAIRE,
        },
        'create': {
            hidden: true,
        },
        'edit': {
            hidden: true,
        },
        'show': {
            type: EntryTypes.STATIC,
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
            layout: 'left',
            transform: (value) => DateHelper.minutesToHoursMin(value),
            hidden: true,
        }
    })
    horaireFin: string;

    @Entry({
        base: {
            label: 'Elève',
            hidden: true,
            flexGrow: 1,
            colOrder: 0,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM_ID,
            transform: (value) =>
                ((value.nom) ? value.nom + ' ' : '')
                + ((value.prenom) ? value.prenom : '')
                + ((value.id) ? ' (' + value.id + ')' : ''),
        },
        'table': {
        },
        'table-prof': {
        }
    })
    eleve: EleveModel;
    @Entry({
        base: {
            label: 'Elève',
            hidden: true,
            flexGrow: 1,
            colOrder: 0,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM_ID,
        },
        'table': {
        },
        'table-prof': {
        }
    })
    eleveLibelle: String;

    @Entry({
        base: {
            label: 'An',
            hidden: true,
            flexGrow: 1,
            colOrder: 9,
            minWidth: TABLE.MIN_WIDTH.AN,
            /*transform: (value) =>
                ((value.nom) ? value.nom + ' ' : '')
                + ((value.prenom) ? value.prenom : '')
                + ((value.id) ? ' (' + value.id + ')' : ''),
                minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,*/
        },
        'table': {
        },
        'table-prof': {
        }
    })
    nbAnneesDansCycle: string; // Uniquement dans le cas de recherche par criteres de cours individuel

    @Entry({
        base: {
            label: 'Inscrits',
            hidden: true,
            minWidth: TABLE.MIN_WIDTH.ID,
        }
    })
    nbElevesInscrits: number;

    @Entry({
        base: {
            label: 'Date début',
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            css: {
                group: 'col-xs-6'
            },
            minWidth: TABLE.MIN_WIDTH.DATE,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            transform: (madate) => (!madate) ? '' : DateHelper.dateBDD2Date(madate).toLocaleDateString(),
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        }
    })
    dateDebut: string;

    @Entry({
        base: {
            label: 'Date fin',
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            css: {
                group: 'col-xs-6'
            },
            minWidth: TABLE.MIN_WIDTH.DATE,
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
            transform: (madate) => (!madate) ? '' : DateHelper.dateBDD2Date(madate).toLocaleDateString(),
            css: {
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        }
    })
    dateFin: string;

    @Entry({
        base: {
            type: EntryTypes.TEXTAREA,
            css: {
                group: 'col-lg-12 col-xs-12',
            },
            label: 'Saisie libre'
        },
        'create': {},
        'edit': {},
        'show': {
            type: EntryTypes.STATIC,
            layout: 'right',
        },
    })
    saisieLibre: string;

    @Entry({
        base: {
            hidden: true,
        },
        'create': {
            hidden: true,
            // nested: true,
            multiple: true,
        },
        'show': {
        },
        'edit': {
            hidden: false,
            // nested: true,
            // multiple: true,
        },
        'tableCours': {
            hidden: false,
            // multiple: true,
            /*type: EntryTypes.TABLE,
            mode: TableMode.EDITABLE,
            model: InscriptionModel,
            title: 'InscriptionsXXX',
            multiple: true,
            css: {
				box: 'panel panel-default col-xs-6 col-md-4 col-lg-3',
			},*/
        },
    })
    inscriptions: InscriptionModel[];

    constructor(data?) {
        super();
        this.setCours(data);
    }

    setCours(data) {
        if (!data) {
            data = {};
        }

        Object.assign(this, data);
        this.anneeScolaire = +data.anneeScolaire;
        this.jour = +data.jour;

        this.professeurLibelle = data.professeur ? `${data.professeur.nom ? data.professeur.nom : ''} ${data.professeur.prenom ? data.professeur.prenom : ''}` : '';
        this.eleveLibelle = data.eleve ?
            (data.eleve.nom ? data.eleve.nom + ' ' : '')
            + (data.eleve.prenom ? data.eleve.prenom : '')
            : '';
        this.salleLibelle = data.salle ? data.salle.nom : '';
        this.libelleCycleNiveau = ((data.cycleLibelle) ? data.cycleLibelle + ' ' : '')
                + ((data.cycleLibelle && data.niveauLibelle) ? '/ ' : '')
                + ((data.niveauLibelle) ? data.niveauLibelle : ''),
        this.inscriptions = [];
        if (data.inscriptions instanceof Array) {
            data.inscriptions.forEach((inscription) => {
                this.inscriptions.push(new InscriptionModel(inscription));
            });
        }

        this.nbElevesInscrits = this.nbElevesInscrits ? this.nbElevesInscrits : 0;
        this.nbPlacesDisponibles = (this.nbElevesMax && this.nbElevesInscrits) ? this.nbElevesMax - this.nbElevesInscrits : null;
    }

}




// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/cours/models/cours.model.ts